import Pic from "../../../assets/images/about2sec.png";
import { Title } from "../../global/title/title";
export const Sec2 = () => {
  return (
    <div className="about-sec  about-sec-2 section">
      <div className="about-sec__box    about-sec__box--text about-sec__box--text-left">
        <Title black="What Are We Doing" blue="" />
        <p className="paragraph text--gray ">
          Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
          sint. Velit officia consequat duis enim velit mollit. Exercitation
          veniam consequat sunt nostrud amet.
        </p>
        <p className="paragraph text--gray">
          Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
          sint. Velit officia consequat duis enim velit mollit. Exercitation
          veniam consequat sunt nostrud amet.
        </p>
      </div>
      <div className="about-sec__box">
        <img src={Pic} alt="img1" className="about-sec__img" />
      </div>
      <div className="about-sec__elapses about-sec__elapses-2">
        <Elapses />
      </div>
    </div>
  );
};
const Elapses = () => {
  return (
    <svg
      width="235"
      height="427"
      viewBox="0 0 235 427"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.2034 426.407C-96.3598 426.407 -192 330.767 -192 213.203C-192 95.6402 -96.3598 0 21.2034 0C138.767 0 234.407 95.6402 234.407 213.203C234.38 330.767 138.74 426.407 21.2034 426.407ZM21.2034 2.69374C-94.8929 2.69374 -189.333 97.1338 -189.333 213.23C-189.333 329.327 -94.8929 423.767 21.2034 423.767C137.3 423.767 231.74 329.327 231.74 213.23C231.74 97.1338 137.273 2.69374 21.2034 2.69374Z"
        fill="#3376FE"
        fill-opacity="0.2"
      />
      <path
        d="M21.205 405.817C-84.9966 405.817 -171.409 319.404 -171.409 213.203C-171.409 107.001 -84.9966 20.5889 21.205 20.5889C127.407 20.5889 213.819 107.001 213.819 213.203C213.819 319.431 127.407 405.817 21.205 405.817ZM21.205 25.9497C-82.0629 25.9497 -166.075 109.962 -166.075 213.229C-166.075 316.497 -82.0629 400.509 21.205 400.509C124.473 400.509 208.485 316.497 208.485 213.229C208.485 109.962 124.473 25.9497 21.205 25.9497Z"
        fill="#3376FE"
        fill-opacity="0.2"
      />
      <path
        d="M21.2005 352.343C-55.5037 352.343 -117.913 289.934 -117.913 213.23C-117.913 136.526 -55.5037 74.1173 21.2005 74.1173C97.9046 74.1173 160.313 136.526 160.313 213.23C160.313 289.934 97.9046 352.343 21.2005 352.343ZM21.2005 79.4247C-52.5699 79.4247 -112.579 139.433 -112.579 213.204C-112.579 286.974 -52.5699 346.983 21.2005 346.983C94.9709 346.983 154.979 286.974 154.979 213.204C154.979 139.46 94.9709 79.4247 21.2005 79.4247Z"
        fill="#3376FE"
        fill-opacity="0.2"
      />
      <path
        d="M21.2036 328.42C-42.3254 328.42 -94.0127 276.733 -94.0127 213.204C-94.0127 149.675 -42.3254 97.9873 21.2036 97.9873C84.7326 97.9873 136.42 149.675 136.42 213.204C136.42 276.759 84.7326 328.42 21.2036 328.42ZM21.2036 100.654C-40.8585 100.654 -91.3457 151.141 -91.3457 213.204C-91.3457 275.266 -40.8585 325.753 21.2036 325.753C83.2657 325.753 133.753 275.266 133.753 213.204C133.753 151.168 83.2657 100.654 21.2036 100.654Z"
        fill="#3376FE"
        fill-opacity="0.2"
      />
      <path
        d="M21.204 284.894C-18.3216 284.894 -50.4595 252.756 -50.4595 213.231C-50.4595 173.705 -18.3216 141.567 21.204 141.567C60.7296 141.567 92.8674 173.705 92.8674 213.231C92.8674 252.73 60.7029 284.894 21.204 284.894ZM21.204 146.875C-15.3612 146.875 -45.1254 176.639 -45.1254 213.204C-45.1254 249.769 -15.3612 279.534 21.204 279.534C57.7691 279.534 87.5333 249.769 87.5333 213.204C87.5333 176.639 57.7691 146.875 21.204 146.875Z"
        fill="#3376FE"
        fill-opacity="0.2"
      />
      <path
        d="M21.2016 248.835C1.57212 248.835 -14.4036 232.86 -14.4036 213.23C-14.4036 193.601 1.57212 177.598 21.2016 177.598C40.831 177.598 56.8332 193.574 56.8332 213.23C56.8065 232.86 40.831 248.835 21.2016 248.835ZM21.2016 180.265C3.039 180.265 -11.7365 195.041 -11.7365 213.23C-11.7365 231.419 3.039 246.168 21.2016 246.168C39.3641 246.168 54.1662 231.393 54.1662 213.23C54.1662 195.068 39.3641 180.265 21.2016 180.265Z"
        fill="#3376FE"
        fill-opacity="0.2"
      />
    </svg>
  );
};
